import { Component, Inject } from "@angular/core";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import { WorkGroupsDataService } from "../../core/workgroups.dataservice";
import { EditBase } from "../../settings/shared/edit.base";

@Component({
    selector: "crew-edit-work-group",
    template: require('./work-group.edit.component.html')
})
export class EditWorkGroupComponent extends EditBase<Nema.Crew.Model.WorkGroup> {

    constructor(
        stateService: StateService,
        transitionService: TransitionService,
        dialog: MatDialog,
        @Inject('workGroup') entity: Nema.Crew.Model.WorkGroup,
        @Inject('workplaces') public workplaces: Nema.Crew.Model.Workplace[],
        @Inject('persons') public persons: Nema.Crew.Model.Person[],
        @Inject(WorkGroupsDataService.Id) private workGroupDataService: WorkGroupsDataService,
        @Inject('$log') $log: ng.ILogService,
        @Inject('isNew') isNew: boolean) {

        super(stateService, transitionService, dialog, entity, workGroupDataService, $log, isNew);

        if (!isNew) {
            (<any>this.entity.WorkGroupPersons).load();
        }

        this.persons = this.persons.filter(p => p.Active);
        this.selectedPersons = this.entity.WorkGroupPersons.map(e => e.Person).filter(p => p.Active);
    }

    public entityDisplayName = "Work Group";

    public listStateName = "app.resources.workgroups";

    public selectedPersons: Nema.Crew.Model.Person[];

    public save(): Promise<void> {
        this.removePersonsNotSelected();
        this.addSelectedPersons();
        return super.save();
    }

    private addSelectedPersons(): void {
        this.selectedPersons.forEach(selectedPerson => {
            if (!this.entity.WorkGroupPersons.some(wgp => wgp.Person.Id === selectedPerson.Id)) {
                const workGroupPerson = this.workGroupDataService.newWorkGroupPerson(selectedPerson.Id);
                this.entity.WorkGroupPersons.push(workGroupPerson);
            }
        });
    }

    private removePersonsNotSelected(): void {
        this.entity.WorkGroupPersons.forEach(workGroupPerson => {
            if (!this.selectedPersons.some(selectedPerson => selectedPerson.Id === workGroupPerson.Person.Id)) {
                this.workGroupDataService.removeMapping(workGroupPerson, () => { });
            }
        })
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/workgroups/work-group.edit.component.ts